import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useMemo, useState } from 'react';
import { Box, Button, Checkbox, Column, Popover } from 'seagull';
import { getTestIds } from 'seagull/utils/TestIds';
import { useLocaleKeys } from '~/i18n';
import { FilterChip } from '../FilterChip/FilterChip';
import { valueLabelFor } from './MultiSelectChip.utils';
export const GetMultiSelectChipTID = (parentTestId)=>getTestIds(parentTestId);
export const MultiSelectChip = (param)=>{
    let { testId, fieldLabel, showVerb, options, value, onChange, onRemove, biPrefix } = param;
    const { MultiSelectChipTestIds } = useMemo(()=>GetMultiSelectChipTID(testId), [
        testId
    ]);
    const { t } = useLocaleKeys('common.filter');
    const { t: operatorTexts } = useLocaleKeys('agreement.aiChipOperator');
    const { t: valueTexts } = useLocaleKeys('agreement.aiChipValue');
    const [anchorEl, setAnchorEl] = useState(null);
    const [draft, setDraft] = useState(value);
    const rawValue = valueLabelFor(options, value, valueTexts);
    const valueLabel = showVerb ? rawValue : rawValue.toLowerCase();
    const openPopover = (event)=>{
        setDraft(value);
        setAnchorEl(event.currentTarget);
    };
    const closePopover = ()=>setAnchorEl(null);
    const toggle = (optionValue)=>setDraft((current)=>current.includes(optionValue) ? current.filter((v)=>v !== optionValue) : [
                ...current,
                optionValue
            ]);
    const apply = ()=>{
        onChange([
            ...draft
        ]);
        closePopover();
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(FilterChip, {
                testId: testId,
                fieldLabel: fieldLabel,
                valuePrefix: showVerb ? operatorTexts.is() : undefined,
                valueLabel: valueLabel,
                onValueClick: openPopover,
                onRemove: onRemove,
                removeBiName: "".concat(biPrefix, "_remove")
            }),
            /*#__PURE__*/ _jsx(Popover, {
                testId: MultiSelectChipTestIds.EditPopover(),
                open: anchorEl != null,
                anchorEl: anchorEl,
                onClose: closePopover,
                children: /*#__PURE__*/ _jsx(Box, {
                    padding: 12,
                    children: /*#__PURE__*/ _jsxs(Column, {
                        gap: 8,
                        children: [
                            options.map((option)=>/*#__PURE__*/ _jsx(Checkbox, {
                                    testId: MultiSelectChipTestIds.Option(option.value),
                                    bi: {
                                        name: "".concat(biPrefix, "_option")
                                    },
                                    checked: draft.includes(option.value),
                                    onChange: ()=>toggle(option.value),
                                    label: option.label
                                }, option.value)),
                            /*#__PURE__*/ _jsx(Button, {
                                testId: MultiSelectChipTestIds.ApplyButton(),
                                bi: {
                                    name: "".concat(biPrefix, "_apply")
                                },
                                onClick: apply,
                                children: t.apply()
                            })
                        ]
                    })
                })
            })
        ]
    });
};
